/**
 * Embed postMessage protocol — Phase 4-2 / T7.
 *
 * Defines the typed envelope and all host<->widget message shapes for the
 * iframe embed. All messages travel as `EmbedEnvelope<T>` over postMessage.
 *
 * `v: 1` is the current protocol version. Bump only on breaking changes.
 */
// ---------------------------------------------------------------------------
// Narrowing helpers — one per message type
// ---------------------------------------------------------------------------
/** True if msg is a valid envelope (shape check only). */
export function isEnvelope(msg) {
    return (typeof msg === 'object' &&
        msg !== null &&
        msg.v === 1 &&
        typeof msg.type === 'string' &&
        typeof msg.id === 'string' &&
        'data' in msg);
}
// Host -> Widget narrowers
export function isInit(msg) {
    return msg.type === 'init';
}
export function isSetTheme(msg) {
    return msg.type === 'setTheme';
}
export function isSetCustomerContext(msg) {
    return msg.type === 'setCustomerContext';
}
export function isCustomerUpdated(msg) {
    return msg.type === 'customerUpdated';
}
export function isSignout(msg) {
    return msg.type === 'signout';
}
// Widget -> Host narrowers
export function isReady(msg) {
    return msg.type === 'ready';
}
export function isResize(msg) {
    return msg.type === 'resize';
}
export function isUnreadCount(msg) {
    return msg.type === 'unreadCount';
}
export function isOpenHostEntity(msg) {
    return msg.type === 'openHostEntity';
}
export function isCreateHostEntityRequest(msg) {
    return msg.type === 'createHostEntityRequest';
}
export function isNotify(msg) {
    return msg.type === 'notify';
}
//# sourceMappingURL=protocol.js.map